import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TermsOfServicePage } from './terms-of-service.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { SharedModule } from "../../shared/shared/shared.module";


const homeRoutes: Routes = [
  {
    path: '',
    component: TermsOfServicePage
  }
];

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    ComponentsModule,
    RouterModule.forChild(homeRoutes),
    SharedModule
],
  declarations: [
    TermsOfServicePage
  ],
  providers: [
  ]
})
export class TermsOfServicePageModule {}
